import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import IconButton, { type IconButtonProps } from '@mui/material/IconButton';
import { forwardRef } from 'react';

export const PreviousIconButton = forwardRef<HTMLButtonElement, IconButtonProps>((props, ref) => (
  <IconButton ref={ref} {...props} data-test="calendar-previous-month-button">
    <ChevronLeftIcon />
  </IconButton>
));
PreviousIconButton.displayName = 'PreviousIconButton';

export const NextIconButton = forwardRef<HTMLButtonElement, IconButtonProps>((props, ref) => (
  <IconButton ref={ref} {...props} data-test="calendar-next-month-button">
    <ChevronRightIcon />
  </IconButton>
));
NextIconButton.displayName = 'NextIconButton';

export const SwitchViewButton = forwardRef<HTMLButtonElement, IconButtonProps>((props, ref) => (
  <IconButton {...props} ref={ref} data-test="calendar-switch-view-button">
    <ArrowDropDownIcon />
  </IconButton>
));
SwitchViewButton.displayName = 'SwitchViewButton';
